import { createModal } from '/@/core/elements/modal'

interface MoreLikeThisModalData {
  imageUrls: string[]
  onSubmit: (imageUrl: string) => void
}

const { api, component } = createModal<MoreLikeThisModalData>(
  'MoreLikeThisModal',
  () => import('./MoreLikeThisModal.vue'),
)

export const useMoreLikeThisModal = api
export default component
